var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStakeFilled = function SvgStakeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.377 7.836c0 1.243 1 2.243 3 4.243l.444.444c2 2 3 3 4.242 3 1.243 0 2.243-1 4.243-3l.444-.444c2-2 3-3 3-4.243 0-1.242-1-2.242-3-4.242l-.444-.444c-2-2-3-3-4.243-3-1.242 0-2.242 1-4.242 3l-.444.444c-2 2-3 3-3 4.242Zm11.367-.84a1 1 0 0 0-1.504-1.319L9.06 7.024l-.845-.88a1 1 0 0 0-1.429-.015l-2 2A1 1 0 1 0 6.2 9.543l1.279-1.278.893.93a1 1 0 0 0 1.473-.033l1.9-2.166Z"
  })));
};
export default SvgStakeFilled;